/*
 *
 * Snackbar constants
 *
 */

export const OPEN = 'claris-vnext/Snackbar/OPEN';
export const CLOSE = 'claris-vnext/Snackbar/CLOSE';
